import React, { useEffect, Fragment } from 'react'
import { Typography } from '@mui/material'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { GenericTableV2 } from '../../../components/_EOS/GenericTable/GenericTableV2'
import { getVasRuleLogColumnsConfig } from '../../ProductAdmin/config/tableColumns'
import { VasRuleLog } from '../../../interfaces/VasRule/VasRule'
import { Loading } from '../../../components/UI'
import { getVasRuleLogs } from '../api'

interface VasRuleLogModalProps {
  skuId: number
}

export const VasRuleLogModal: React.FC<VasRuleLogModalProps> = ({ skuId }) => {
  const { state: logsState, callApi: callGetLogs } = useApi<VasRuleLog[]>()

  useEffect(() => {
    callGetLogs(getVasRuleLogs(skuId))
  }, [])

  const columnsConfig = getVasRuleLogColumnsConfig()

  if (logsState.status === Status.Loading) {
    return <Loading />
  }

  return (
    <Fragment>
      <Typography variant='body2' color='textSecondary' sx={{ mb: 2 }}>
        Aquí puedes visualizar todas las acciones asociadas a este producto
        respecto a reglas VAS.
      </Typography>

      <GenericTableV2<VasRuleLog>
        data={logsState?.data || []}
        columns={columnsConfig}
        keyField='createdAt'
      />
    </Fragment>
  )
}
